export default __webpack_public_path__ + "static/media/icons8-opera-240.9463ceff.png";